var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgOrangeStripe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 51,
    viewBox: "0 0 341 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_945_1841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.279 0.170898H105.779L55.4792 50.4709H58.9792L109.279 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.279 0.170898H121.779L71.4792 50.4709H74.9792L125.279 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.279 0.170898H137.779L87.4792 50.4709H90.9792L141.279 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.279 0.170898H153.779L103.479 50.4709H106.979L157.279 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.379 0.170898H169.779L119.479 50.4709H122.979L173.379 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37915 50.4709H10.8792L61.2792 0.170898H57.7792L7.37915 50.4709Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2792 0.170898H25.6791L0.37915 25.4709V29.0709L29.2792 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2792 0.170898H41.7792L0.37915 41.5709V45.0709L45.2792 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2792 0.170898H89.7792L39.3792 50.4709H42.9791L93.2792 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2792 0.170898H73.7792L23.3792 50.4709H26.9792L77.2792 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.379 0.170898H185.779L135.479 50.4709H138.979L189.379 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2792 0.170898H9.67915L0.37915 9.4709V13.0709L13.2792 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.379 0.170898H297.879L247.579 50.4709H251.079L301.379 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.479 25.1709V21.6709L311.579 50.4709H315.079L340.479 25.1709Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.379 0.170898H313.879L263.579 50.4709H267.079L317.379 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.479 0.170898H329.879L279.579 50.4709H283.079L333.479 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.579 50.4709H299.079L340.479 9.1709V5.6709L295.579 50.4709Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.479 41.1709V37.6709L327.579 50.4709H331.079L340.479 41.1709Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.379 0.170898H233.879L183.479 50.4709H187.079L237.379 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.379 0.170898H217.879L167.479 50.4709H170.979L221.379 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.379 0.170898H281.879L231.579 50.4709H235.079L285.379 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.379 0.170898H201.779L151.479 50.4709H154.979L205.379 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.379 0.170898H265.879L215.479 50.4709H219.079L269.379 0.170898Z",
    fill: "#E0410E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.379 0.170898H249.879L199.479 50.4709H203.079L253.379 0.170898Z",
    fill: "#E0410E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_945_1841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340.1,
    height: 50.3,
    fill: "white",
    transform: "translate(0.37915 0.170898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStripe);
export default __webpack_public_path__ + "static/media/orangeStripe.239a6ec952194a24688145cd452b538f.svg";
export { ForwardRef as ReactComponent };